import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './provision-modal.css';
import Spinner from '../../../components/spinner/Spinner';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import QRCode from 'qrcode.react';
import InputField from '../../../components/input-field/InputField';
const connect = new RESTService();
const RS = new RoutingService();

class ProvisionModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: 'Provision Application',
			saving: false,
			editing: false,
			animationCls: 'zoomIn',
			url: this.getUrl(),
			environment: props.environment
		};
	};

	getUrl = () => {
		let config = RS.getCurrentConfiguration();
		if (config && config.instanceConfig && config.instanceConfig.assetsUrl) {
			return config.instanceConfig.assetsUrl;
		}
		return 'NOT SET';
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
				RS.setCurrentEnvironment(nextProps.environment);
			});
			connect
				.getAppConfig({
					name: RS.getCurrentApplication()
				})
				.then(res => {
					RS.setCurrentConfiguration(res.data);
				});
		}
	}

	onSave = () => {
		this.setData('saving', true);

		let config = RS.getCurrentConfiguration();
		let instanceConfig = config.instanceConfig;
		if (!instanceConfig) {
			instanceConfig = {};
		}
		instanceConfig.assetsUrl = this.data.url;
		connect
			.updateAppConfigSegment('instanceConfig', instanceConfig, config.name)
			.then(res => {
				RS.setCurrentConfiguration(res.data);
				this.observe(() => {
					this.data.editing = false;
					this.data.saving = false;
				});
				RS.showSuccess();
			})
			.catch(err => {
				this.observe(() => {
					this.data.saving = false;
				});
				RS.smartError(err);
			});
	};

	onClose = () => {
		this.setData('animationCls', 'zoomOut');
		setTimeout(() => {
			this.props.onClose();
		}, 250);
	};

	buildProvisionUrl = () => {
		let url = process.env.SERVER_NAME;
		return `https://${RS.getCurrentTenant()}.${url}/api/v2/composer/${this.data.environment}/${RS.getCurrentApplication()}/application/configuration`;
	};

	onURLChange = evt => {
		this.setData('url', evt.target.value);
	};

	onToggleEdit = () => {
		this.setData('editing', !this.data.editing);
	};

	render() {
		let { isOpen } = this.props;
		let { title, saving, url, editing, animationCls } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className={`provision-modal animated ${animationCls}`}
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				{saving ? (
					<Spinner text="Saving..." height="267px" />
				) : (
					<div className="modal-body vbox hcenter">
						<QRCode value={this.buildProvisionUrl()} fgColor="#000" size={200} />
						<div className="url">{this.buildProvisionUrl()}</div>
						<div className="inline-edit hbox vcenter">
							<InputField
								className="instance-url"
								label="Assets Url"
								subText="URL for bundled assets."
								type="text"
								name="url"
								value={url}
								handleChange={this.onURLChange}
								required
								disabled={!editing}
							/>
							{!editing && (
								<button className="btn square inline-btn vbox vcenter hcenter" onClick={this.onToggleEdit}>
									<i className="mdi mdi-pencil" />
								</button>
							)}
						</div>
					</div>
				)}
				<div className="btn-ctn">
					{!editing && (
						<button className="btn cancel-btn" onClick={this.onClose} disabled={saving}>
							Close
						</button>
					)}
					{editing && (
						<div className="hbox vcenter">
							<button className="btn cancel-btn" onClick={this.onToggleEdit}>
								Cancel
							</button>
							<button className="btn primary" onClick={this.onSave} disabled={saving}>
								Save Changes
							</button>
						</div>
					)}
				</div>
			</Modal>
		);
	}
}
export default ProvisionModal;



// WEBPACK FOOTER //
// ./src/views/environments-panel/provision-modal/ProvisionModal.js